import React from 'react';

import { Spinner } from '@components';

import './button.scss';

interface ButtonProps {
  text: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => unknown;
  classNames?: string;
  loading?: boolean;
  disabled?: boolean;
  rightArrow?: boolean;
  leftArrow?: boolean;
  active?: boolean;
  buttonStyle?: 'normal' | 'subtle' | 'outline' | 'wide' | 'search' | 'edit';
}

export function Button(props: ButtonProps) {
  const { classNames, text, loading, onClick, disabled, rightArrow = true, leftArrow, buttonStyle, active } = props;

  return (
    <button
      type='button'
      className={`
        button
        button-${buttonStyle || 'normal'}
        ${classNames && classNames}
        ${disabled && 'disabled'}
        ${leftArrow && !loading && 'left-arrow'}
        ${rightArrow && !loading && 'right-arrow'}
        ${loading && 'loading'}
        ${active && 'active'}
        `}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <Spinner /> : <span>{text}</span>}
    </button>
  );
}
